const { facebook } = require('../../../client-config.js');

export const PLATFORM = {
  FACEBOOK: 'facebook',
  YOUTUBE: 'youtube',
  CUSTOM_RTMP: 'customRtmp',
  INSTAGRAM: 'instagram',
};

export const FACEBOOK = {
  DEFAULT_PERMISSIONS: ['pages_manage_posts', 'pages_read_engagement', 'pages_show_list'],
  SOCIAL_SELLING_PERMISSIONS: [
    'pages_manage_posts',
    'pages_read_engagement',
    'pages_manage_engagement',
    'pages_show_list',
    'business_management',
    'pages_messaging',
    'pages_read_user_content',
    //'publish_video',
    //'read_insights',
  ],
};

/**
 * We use a configuration id for Instagram specifically because
 * we want to enable the Instagram tailored login flow.
 * Defaults to test configuration id.
 * At time of writing this includes the following permissions:
 * instagram_basic
 * pages_messaging
 * pages_show_list
 * instagram_manage_comments
 * business_management
 * instagram_manage_messages
 * pages_manage_metadata
 * pages_read_engagement
 */
export const INSTAGRAM_CONFIGURATION_ID
  = facebook?.instagramConfigurationId ?? '888109006013550';

export const INSTAGRAM_SCOPES = [
  'business_management',
  'instagram_basic',
  'instagram_manage_comments',
  'instagram_manage_messages',
  'pages_manage_metadata',
  'pages_messaging',
  'pages_read_engagement',
  'pages_show_list',
];

export const AUTH_STORAGE_KEY = '_bamls_socialMediaAuth';
